import { getApiOrigin } from "@utils/apiOrigin";

const BASE_URL = getApiOrigin();

export interface ContactSubmission {
  email: string;
  first_name: string;
  last_name: string;
  message: string;
}

export interface ContactResponse {
  status: number;
  message: string;
  data: {
    contact: {
      id: number;
      first_name: string;
      last_name: string;
      email: string;
      message: string;
      created_at: string;
      updated_at: string;
    };
    email_sent: {
      status: number;
      message: string;
    };
  };
}

export async function submitContactForm(
  data: ContactSubmission
): Promise<ContactResponse> {
  console.log("Base URL:", { BASE_URL });
  const response = await fetch(`${BASE_URL}/api/v1/contact-us/submit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(
      `Failed to submit contact form (${response.status}) ${errorText}`
    );
  }

  return (await response.json()) as ContactResponse;
}
